import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import CaseItemLink from './CaseItemLink';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
    root: {
      //width: '100%',
    //   maxWidth: 230,
      //float:'left'
    },
  });

const CaseItemLinkList = (props) => {
    const {classes, caseItems, context } = props;
    // console.log('CaseItemLinkList caseItems: '+caseItems.length)
    if (caseItems.length == 0 || caseItems == undefined){
        if(localStorage.getItem('typeOfAccount') == 'arbitrator'){
            return (
                <div className={classes.divStyle}>
                <h4 className={classes.paper}> {context.t('There is no case in this account. Please contact admin.')} </h4>
                </div>
            );
        }
        else if (localStorage.getItem('typeOfAccount') == 'admin'){
            return (
                <div className={classes.divStyle}>
                <h4 className={classes.paper}> {context.t('There is no case in this account. Please contact support.')} </h4>
                </div>
            );
        }
        else{
            return (
                <div className={classes.divStyle}>
                <h4 className={classes.paper}> {context.t('There is no case in this account. Please contact HKARBSOC.')} </h4>
                </div>
            );
        }
    }
    else{
        return (
            <div className={classes.root}>
                {
                    caseItems.length == 1 ? props.history.push(`${props.match.path}/${caseItems[0].caseId}`) : null
                }   
                <Grid container direction="row" justifyContent="center" alignItems="center" >
                    {
                        caseItems.map((title, index) => ( 
                            <React.Fragment key={index}>
                                <CaseItemLink primary={title} />
                            </React.Fragment>   
                        ))
                    }
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(withRouter(CaseItemLinkList));